module.exports = __webpack_public_path__ + "static/media/cart-disabled.a13f6622.svg";